import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import quickbookApi from '~/apis/quickbook';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { handleGetQuickbook } from '~/thunks/quickbook/quickbookThunk';
import { STORAGE_QUICKBOOK_PREVOUS_URL } from '~/utils/constants/quickbook';
import { catchError, notify } from '~/utils/helper';

const useQuickbook = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const location = useLocation();
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  const { quickbook } = useAppSelector((state) => state.quickbook);
  const { t } = useTranslation('admin/quickbook');
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (!quickbook) {
      dispatch(handleGetQuickbook());
    }
  }, [dispatch, quickbook]);
  //#endregion Implement Hook

  //#region Handle Function
  const connectQuickbook = async () => {
    try {
      const response = await quickbookApi.getAuthUrl();
      localStorage.setItem(STORAGE_QUICKBOOK_PREVOUS_URL, location.pathname);
      window.location.href = response.data.data.authUrl;
      return false;
    } catch (e: unknown) {
      catchError(e, (message) => {
        notify('error', message);
      });
      return true;
    }
  };

  const disconnectQuickbook = async () => {
    try {
      await quickbookApi.disconnect();
      dispatch(handleGetQuickbook());
      notify('success', t('admin/quickbook:disconnectSuccess'));
      return false;
    } catch (e: unknown) {
      catchError(e, (message) => {
        notify('error', message);
      });
      return true;
    }
  };

  const fetchQuickbook = () => {
    dispatch(handleGetQuickbook());
  };
  //#endregion Handle Function

  return { connectQuickbook, quickbook, disconnectQuickbook, fetchQuickbook };
};

export default useQuickbook;
